exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2223J{padding-top:30px}._1vn8g,._2223J{margin:0 auto;max-width:1080px}._1vn8g{width:100%;display:block}._2cCdZ{margin-top:24px}._1Y1T9{text-align:right}._1bxCO{text-align:left}._2gEzX{text-align:center}.DMvIZ{padding:0}._2sClg{border-color:#eb6f6f;background-color:#eb6f6f;color:#fff;float:right;font-size:16px}._2sClg:hover{background:rgba(54,50,119,.8)}._2sClg:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}._1PvcY{border-color:#d04d4d;background-color:#d04d4d;color:#fff}._3-oYP{padding:9px 27px}._1PvcY:active,._1PvcY:active:focus,._1PvcY:active:hover,._1PvcY:focus,._1PvcY:hover{border-color:#eb6f6f;background-color:#eb6f6f;color:#fff}._27mWj{border-color:#d04d4d;color:#d04d4d;background-color:#fff}._27mWj:active,._27mWj:active:focus,._27mWj:active:hover,._27mWj:focus,._27mWj:hover{border-color:#eb6f6f;color:#eb6f6f;background-color:#fff}._3ggv1{padding:5px 0}.igpxE{border-radius:0;width:100%;display:block;color:#484848;font-size:16px;padding-bottom:12px;border-bottom:1px solid #dce0e0}._2h4zP{margin-bottom:6px}._2Jcu7{padding:10px 35px 10px 10px}._2Jcu7,._14ZhB{height:40px;border-radius:2px;font-size:14px;border:1px solid #aaa;background-color:#fff;color:#484848;font-weight:400}._14ZhB{padding:10px 32px 10px 10px}._1glew{position:relative;display:inline-block;vertical-align:bottom;margin-right:5px}._3afs-{overflow:hidden}._13nBA{font-size:16px;color:#484848;margin:6px 0}._2DrXD{font-size:14px;color:#767676;margin:6px 0;line-height:1.43;font-weight:400}.ElcFS{color:#008489}._129GR{font-size:16px;line-height:32px}.ElcFS:focus,.ElcFS:hover{color:#008489;text-decoration:underline}@media screen and (max-width:768px){._1qnkI{padding:0}}@media screen and (max-width:640px){._1btAH{margin-bottom:18px}}", ""]);

// exports
exports.locals = {
	"container": "_2223J",
	"landingContainer": "_1vn8g",
	"spaceTop4": "_2cCdZ",
	"textAlignRight": "_1Y1T9",
	"textAlignLeft": "_1bxCO",
	"textAlignCenter": "_2gEzX",
	"noPadding": "DMvIZ",
	"button": "_2sClg",
	"btnPrimary": "_1PvcY",
	"btnlarge": "_3-oYP",
	"btnPrimaryBorder": "_27mWj",
	"btnSmall": "_3ggv1",
	"panelHeader": "igpxE",
	"formGroup": "_2h4zP",
	"formControlInput": "_2Jcu7",
	"formControlSelect": "_14ZhB",
	"select": "_1glew",
	"formSection": "_3afs-",
	"captionText": "_13nBA",
	"labelText": "_2DrXD",
	"modalCaptionLink": "ElcFS",
	"modalCaptionLinkLarge": "_129GR",
	"smPadding": "_1qnkI",
	"smBottom": "_1btAH"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/static/whyhost/WhyHost.css
// module id = 2651
// module chunks = 15